export default "__VITE_ASSET__fbe0ff32__"